import type { Bruker } from '@klp/user';
import { userSelectors } from '@klp/user/userSlice';
import { useGetCurrentUserQuery } from '@klp/user/services/rtkApi';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from '@klpkonsern/auth-core';

export const useCurrentUser = () => {
    const { authenticatedOidcUser, isAuthenticatedOidcUser, hasRole } =
        useAuth();
    const isAdmin = hasRole('admin');
    const isEDAdmin = hasRole('ed-admin');

    const { data: userData, isLoading: currentUserIsLoading } =
        useGetCurrentUserQuery(
            { isAdmin, isEDAdmin },
            {
                skip: !isAuthenticatedOidcUser,
            },
        );

    const { devRoleOverride } = useSelector(userSelectors);

    const currentUser = useMemo(() => {
        if (!isAuthenticatedOidcUser || !authenticatedOidcUser || !userData) {
            return undefined;
        }
        const base = { ...userData, isAdmin, isEDAdmin } as Bruker;
        return devRoleOverride ? { ...base, ...devRoleOverride } : base;
    }, [
        isAuthenticatedOidcUser,
        authenticatedOidcUser,
        userData,
        isAdmin,
        isEDAdmin,
        devRoleOverride,
    ]);

    return {
        isAuthenticated: isAuthenticatedOidcUser,
        currentUser,
        currentUserIsLoading,
        isAdmin: currentUser?.isAdmin ?? isAdmin,
        isEDAdmin: currentUser?.isEDAdmin ?? isEDAdmin,
    };
};
